import { render } from "./MyCherry.vue?vue&type=template&id=b6db4938&scoped=true"
import script from "./MyCherry.vue?vue&type=script&lang=js"
export * from "./MyCherry.vue?vue&type=script&lang=js"

import "./MyCherry.vue?vue&type=style&index=0&id=b6db4938&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6db4938"]])

export default __exports__